import { createContext } from 'react';

const SiteContext = createContext('STANDARD');
SiteContext.displayName = 'SiteDisplayMode';

export default SiteContext;
